import tw, { styled } from "twin.macro";

const Label = styled.span`
    ${tw`block mb-2 text-xs font-bold tracking-wide text-color-light`}
`;

export default Label;